export const education = [
    {   
        school : "University of Arizona", 
        degree: "Master of Science (MS)",
        major: "Cybersecurity & Machine Learning",
        start_date: "Aug 2020",
        end_date: "May 2022",
        location: "Tucson, AZ",
        gpa: "4.0 / 4.0",
        honors: "AZSecure Scholarship-For-Service (SFS) Recipient"
    }, 
    {   
        school : "Iona College", 
        degree: "Bachelor of Science (BS)",
        major: "Computer Science & Mathematics",
        start_date: "Aug 2017",
        end_date: "May 2020",
        location: "New Rochelle, NY",
        gpa: "4.0 / 4.0",
        honors: "Computer Science Award & NY Presidential Scholarship",
    },
    {   
        school : "Suffolk County Community College", 
        degree: "Associate of Arts (AA)",
        major: "Liberal Arts: General Studies",
        start_date: "Jan 2016",
        end_date: "May 2017",
        location: "Riverhead, NY",
        gpa: "3.9 / 4.0",
        honors: "Dean's List",
    }
]